import { toast } from 'react-toastify';

const notify = (message) => toast(message);

export default notify;
